import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { WidgetWrite, WidgetWriteEvent } from './widget-write.model';

@Injectable({ providedIn: 'root' })
export class WidgetWriteTrackerService {
  private readonly pendingByWidget = new Map<number, number>();
  private readonly eventsSubject = new Subject<WidgetWriteEvent>();

  public readonly events$: Observable<WidgetWriteEvent> = this.eventsSubject.asObservable();

  public started(write: WidgetWrite): void {
    this.pendingByWidget.set(write.widgetId, this.pending(write.widgetId) + 1);
    this.eventsSubject.next({ write, finished: false });
  }

  public finished(write: WidgetWrite, succeeded: boolean): void {
    this.pendingByWidget.set(write.widgetId, Math.max(0, this.pending(write.widgetId) - 1));
    this.eventsSubject.next({ write, finished: true, succeeded });
  }

  public pending(widgetId: number): number {
    return this.pendingByWidget.get(widgetId) ?? 0;
  }
}
